
// // new admin profile 4 with verificatio status
// import React, { useState, useEffect } from "react";
// import Cookies from "js-cookie";
// import data from "./mock-data.json";
// import "./style.css";

// const ClerkProfile = () => {
//   const [contacts, setContacts] = useState(data);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isResending, setIsResending] = useState(false);
//   const [resendMsg, setResendMsg] = useState("");

//   const [currentPassword, setCurrentPassword] = useState("");
//   const [newPassword, setNewPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [updateMsg, setUpdateMsg] = useState("");
//   const [isUpdating, setIsUpdating] = useState(false);

//   useEffect(() => {
//     const fetchProfile = () => {
//       const adminCookie = Cookies.get("sessionidadmin") || "";
//       const userid = Cookies.get("sessioniduser") || "";

//       if (adminCookie.length || userid.length) {
//         setIsLoading(true);
//         setTimeout(() => {
//           fetch("https://api.terraweb.africa/loadProfileAdmin", {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({ adminid: adminCookie, userid }),
//           })
//             .then((res) => {
//               if (!res.ok) throw new Error("Failed to fetch profile");
//               return res.json();
//             })
//             .then((user) => {
//               if (user[0]?.username) setContacts(user);
//               setIsLoading(false);
//             })
//             .catch(() => setIsLoading(false));
//         }, 150);
//       }
//     };
//     fetchProfile();
//   }, []);

//   const handleResendVerification = async () => {
//     // if (!contacts[0]?.userid) return;

//      const adminCookie = Cookies.get("sessionidadmin") || "";
//       const userid = Cookies.get("sessioniduser") || "";

//     setIsResending(true);
//     setResendMsg("");

//     try {
//       const res = await fetch("https://api.terraweb.africa/resend-verification", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email: contacts[0].email }),
//       });

//       const result = await res.json();
//       if (!res.ok) throw new Error(result || "Failed to resend verification");

//       setResendMsg("Verification email sent! Please check your inbox.");
//     } catch (err) {
//       setResendMsg("Unable to resend verification. Try again later.");
//       console.error(err);
//     } finally {
//       setIsResending(false);
//     }
//   };


//   const handleUpdatePassword = async () => {

//      const adminCookie = Cookies.get("sessionidadmin") || "";
//       const userid = Cookies.get("sessioniduser") || "";

//     // if (!userid||!adminCookie) return;
//     const id = userid || adminCookie;
// if (!id) return;


//     if (!currentPassword || !newPassword || !confirmPassword) {
//       setUpdateMsg("Please fill all password fields");
//       return;
//     }

//     if (newPassword !== confirmPassword) {
//       setUpdateMsg("New password and confirm password do not match");
//       return;
//     }

//     setIsUpdating(true);
//     setUpdateMsg("");

//     try {
//       const res = await fetch("https://api.terraweb.africa/update", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//       id: id,

//           email: contacts[0]?.email,
//           newpass:newPassword,
//           password: currentPassword,
//           confirmPass: confirmPassword,
//         }),
//       });

//       const result = await res.json();

//       if (!res.ok) throw new Error(result || "Failed to update password");

//       setUpdateMsg("✅ Password updated successfully! Check your email for confirmation.");
//       // Reset fields
//       setCurrentPassword("");
//       setNewPassword("");
//       setConfirmPassword("");
//     } catch (err) {
//       setUpdateMsg("❌ Unable to update password. Try again later.");
//       console.error(err);
//     } finally {
//       setIsUpdating(false);
//     }
//   };


//   if (isLoading) {
//     return (
//       <div className="tc mt5">
//         <div className="loader">Loading...</div>
//       </div>
//     );
//   }

//   const user = contacts[0] || {};
//   const verified = user.verified;

//   return (
//     <div className="admin-profile-wrapper mt6">
//       <div className="co-container">
//         {/* Profile Sidebar */}
//         <div className="profile-sidebar">
//           <div className="mr3">
//               <img
//                 className="br-100 h3 w3"
//                 alt="profile"
//                 src={
//                   user?.gender === "female"
//                     ? "/img/femaleavatar.jpg"
//                     : user?.gender === "male"
//                       ? "/img/maleavatar.jpeg"
//                       : "/img/maleavatar.jpeg"
//                 }
//               />
//             </div>
//           <h3 className="username">{user.username}</h3>
//           <p className="email">
//             {user.email}{" "}
//             {verified ? (
//               <span className="verified-badge">Verified</span>
//             ) : (
//               <span className="not-verified-badge">Not Verified</span>
//             )}
//           </p>

//           {!verified && (
//             <>
//               <button
//                 className="resend-btn"
//                 onClick={handleResendVerification}
//                 disabled={isResending}
//               >
//                 {isResending ? "Resending..." : "Resend Verification"}
//               </button>
//               {resendMsg && <div className="resend-msg">{resendMsg}</div>}
//             </>
//           )}

//           <div className="profile-info">
//             <p>
//               <span>Status:</span> {user.status}
//             </p>
//             <p>
//               <span>Company:</span> {user.company}
//             </p>
//           </div>
//         </div>

//         {/* Profile Settings */}
//         <div className="profile-settings">
//           <h4>Profile Settings</h4>

//           {/* Full Name */}
//           <div className="form-group">
//             <label>Full Name</label>
//             <input type="text" disabled value={user.fullname || ""} placeholder="Full Name" />
//           </div>

//           {/* Phone */}
//           <div className="form-group">
//             <label>Mobile Number</label>
//             <input type="text" disabled value={user.phone || ""} placeholder="Phone number" />
//             <span className="confirm-label">Not Confirmed. Click to confirm</span>
//           </div>

//           {/* Email */}
//           <div className="form-group">
//             <label>Email</label>
//             <input type="text" disabled value={user.email || ""} placeholder="Email" />
//             {!verified && (
//               <span className="confirm-label" >Not Verified. Click to resend</span>
//             )}
//           </div>

//           {/* Save */}
//           {/* <div className="btn-container">
//             <button>Save Profile</button>
//           </div> */}
//         </div>

//    {/* Profile Settings */}
//         <div className="profile-settings">
//           <h4>Change Password</h4>

//           <div className="form-group">
//             <label>Current Password</label>
//             <input
//               type="password"
//               placeholder="Current Password"
//               value={currentPassword}
//               onChange={(e) => setCurrentPassword(e.target.value)}
//             />
//           </div>
//           <div className="form-group">
//             <label>New Password</label>
//             <input
//               type="password"
//               placeholder="New Password"
//               value={newPassword}
//               onChange={(e) => setNewPassword(e.target.value)}
//             />
//           </div>
//           <div className="form-group">
//             <label>Confirm New Password</label>
//             <input
//               type="password"
//               placeholder="Confirm New Password"
//               value={confirmPassword}
//               onChange={(e) => setConfirmPassword(e.target.value)}
//             />
//           </div>


//           {/* <div className="btn-container">
//             <button>Update Password</button>
//           </div> */}

//              <div className="btn-container">
//             <button onClick={handleUpdatePassword} disabled={isUpdating}>
//               {isUpdating ? "Updating..." : "Update Password"}
//             </button>
//           </div>

//           {updateMsg && <div className="resend-msg mt2">{updateMsg}</div>}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ClerkProfile;


// new with good shape
// new admin profile 4 with verification status
import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import "./style.css";

const ClerkProfile = () => {
  // FIX: was `contacts` (an array defaulting to mock-data.json), read as
  // `contacts[0]`. The actual API returns { success, data: {...} } - a
  // single object, not an array - so `user[0]` was always undefined and
  // setContacts(user) never ran. The page was silently showing stale
  // mock data forever. Now stores the real profile object directly.
  const [profile, setProfile] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [loadError, setLoadError] = useState("");

  const [isResending, setIsResending] = useState(false);
  const [resendMsg, setResendMsg] = useState("");

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [updateMsg, setUpdateMsg] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    const fetchProfile = () => {
      const adminCookie = Cookies.get("sessionidadmin") || "";
      const userid = Cookies.get("sessioniduser") || "";

      if (!adminCookie.length && !userid.length) {
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      setLoadError("");

      setTimeout(() => {
        fetch("https://api.terraweb.africa/loadProfileClerk", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ adminid: adminCookie, userid }),
        })
          .then((res) => {
            if (!res.ok) throw new Error("Failed to fetch profile");
            return res.json();
          })
          .then((result) => {
            // FIX: read the real shape - { success: true, data: {...} }
            if (result?.success && result.data) {
              setProfile(result.data);
            } else {
              setLoadError("Could not load your profile.");
            }
            setIsLoading(false);
          })
          .catch(() => {
            setLoadError("Could not load your profile. Please try refreshing.");
            setIsLoading(false);
          });
      }, 150);
    };

    fetchProfile();
  }, []);

  const handleResendVerification = async () => {
    if (!profile?.email) return;

    setIsResending(true);
    setResendMsg("");

    try {
      const res = await fetch("https://api.terraweb.africa/resend-verification", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: profile.email }),
      });

      const result = await res.json();
      if (!res.ok) throw new Error(result?.message || "Failed to resend verification");

      setResendMsg("Verification email sent! Please check your inbox.");
    } catch (err) {
      setResendMsg("Unable to resend verification. Try again later.");
      console.error(err);
    } finally {
      setIsResending(false);
    }
  };

  const handleUpdatePassword = async () => {
    const adminCookie = Cookies.get("sessionidadmin") || "";
    const userid = Cookies.get("sessioniduser") || "";
    const id = userid || adminCookie;
    if (!id) return;

    if (!currentPassword || !newPassword || !confirmPassword) {
      setUpdateMsg("Please fill all password fields");
      return;
    }

    if (newPassword !== confirmPassword) {
      setUpdateMsg("New password and confirm password do not match");
      return;
    }

    setIsUpdating(true);
    setUpdateMsg("");

    try {
      const res = await fetch("https://api.terraweb.africa/update", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: id,
          email: profile?.email,
          newpass: newPassword,
          password: currentPassword,
          confirmPass: confirmPassword,
        }),
      });

      const result = await res.json();

      if (!res.ok) throw new Error(result?.message || "Failed to update password");

      setUpdateMsg("✅ Password updated successfully! Check your email for confirmation.");
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      setUpdateMsg("❌ Unable to update password. Try again later.");
      console.error(err);
    } finally {
      setIsUpdating(false);
    }
  };

  if (isLoading) {
    return (
      <div className="tc mt5">
        <div className="loader">Loading...</div>
      </div>
    );
  }

  if (loadError) {
    return (
      <div className="tc mt5">
        <p className="red f4 b">{loadError}</p>
      </div>
    );
  }

  const user = profile || {};

  // FIX: the API response you shared doesn't include a `verified` field
  // at all, so this used to always fall back to "Not Verified" - which
  // is misleading if the account actually IS verified but the backend
  // just doesn't say so. Now it only shows the badge/resend button when
  // the field is actually present. Add `verified` to loadProfileAdmin's
  // response (or tell me the real field name) to restore this properly.
  const hasVerifiedField = user.verified !== undefined ;
  const verified = user.verified;

  // Small helper so null/missing values show "Not set" instead of a
  // blank space that looks broken.
  const displayOr = (value, fallback = "Not set") =>
    value === null || value === undefined || value === "" ? fallback : value;

  return (
    <div className="admin-profile-wrapper mt6">
      <div className="co-container">
        {/* Profile Sidebar */}
        <div className="profile-sidebar">
          <div className="mr3">
            <img
              className="br-100 h3 w3"
              alt="profile"
              src={
                user?.gender === "female"
                  ? "/img/femaleavatar.jpg"
                  : user?.gender === "male"
                  ? "/img/maleavatar.jpeg"
                  : "/img/maleavatar.jpeg"
              }
            />
          </div>
          <h3 className="username">{user.username}</h3>
          <p className="email">
            {user.email}{" "}
            {hasVerifiedField &&
              (verified ? (
                <span className="verified-badge">Verified</span>
              ) : (
                <span className="not-verified-badge">Not Verified</span>
              ))}
          </p>

          {hasVerifiedField && !verified && (
            <>
              <button
                className="resend-btn"
                onClick={handleResendVerification}
                disabled={isResending}
              >
                {isResending ? "Resending..." : "Resend Verification"}
              </button>
              {resendMsg && <div className="resend-msg">{resendMsg}</div>}
            </>
          )}

          <div className="profile-info pa2">
            <p>
              <span>Status:</span> {displayOr(user.status)}
            </p>
            <p>
              <span>Company:</span> {displayOr(user.company)}
            </p>
            <p>
              <span>Role:</span> {displayOr(user.category)}
            </p>
          </div>

          {/* Surfaces totalUsers/totalRecords, which the API already
              sends but the page previously discarded entirely. Remove
              this block if you'd rather keep the sidebar as-is. */}
          {(user.totalUsers !== undefined || user.totalRecords !== undefined) && (
            <div className="profile-info pa2">
              {/* {user.totalUsers !== undefined && (
                <p>
                  <span>Users managed:</span> {user.totalUsers}
                </p>
              )} */}
              {user.totalRecords !== undefined && (
                <p>
                  <span>Total records:</span> {user.totalRecords}
                </p>
              )}
            </div>
          )}
        </div>

        {/* Profile Settings */}
        <div className="profile-settings">
          <h4>Profile Settings</h4>

          {/* Full Name */}
          <div className="form-group">
            <label>Full Name</label>
            <input type="text" disabled value={user.fullname || ""} placeholder="Full Name" />
          </div>

          {/* Phone */}
          <div className="form-group">
            <label>Mobile Number</label>
            <input type="text" disabled value={user.phone || ""} placeholder="Phone number" />
          </div>

          {/* Email */}
          <div className="form-group">
            <label>Email</label>
            <input type="text" disabled value={user.email || ""} placeholder="Email" />
            {hasVerifiedField && !verified && (
              <span className="confirm-label">Not Verified. Click to resend</span>
            )}
          </div>
        </div>

        {/* Change Password */}
        <div className="profile-settings">
          <h4>Change Password</h4>

          <div className="form-group">
            <label>Current Password</label>
            <input
              type="password"
              placeholder="Current Password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>New Password</label>
            <input
              type="password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Confirm New Password</label>
            <input
              type="password"
              placeholder="Confirm New Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>

          <div className="btn-container">
            <button onClick={handleUpdatePassword} disabled={isUpdating}>
              {isUpdating ? "Updating..." : "Update Password"}
            </button>
          </div>

          {updateMsg && <div className="resend-msg mt2">{updateMsg}</div>}
        </div>
      </div>
    </div>
  );
};

export default ClerkProfile;